import { armorAPI } from '~/services/api';

function get() {
  return armorAPI.request({
    url: `/setting/notifications`,
    method: 'GET',
  });
}

function put(data) {
  return armorAPI.request({
    data,
    url: `/setting/notifications`,
    method: 'PUT',
  });
}

function sendSampleEmail(notificationType) {
  return armorAPI.request({
    data: { notification_type: notificationType },
    url: `/order-notifications/send-sample`,
    method: 'POST',
  });
}

export { get, put, sendSampleEmail };
